import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addAchievmentsToState, setLoader } from '../../redux';

import AchievmentSelector from '../../selectors/Achievment';
import AlertMessage from '../../components/AlertMessage';
import ConfirmDelete from '../../components/ConfirmDelete';

import "./style.css";

function DeleteAchievments() {
    const dispatch = useDispatch();

    const [alertMsg, setAlert] = useState([]);
    const [confirm, setConfirm] = useState(false);
    const [toDelete, setToDelete] = useState(null);

    const token = useSelector(state => state.user.token);
    const achievments_db = useSelector(state => state.data.achievments);

    useEffect(() => {
        if (!toDelete || !confirm) return
        dispatch(setLoader(1));
        deleteAchievment();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toDelete, confirm])

    const deleteAchievment = async () => {
        const req = await fetch(`https://api.pro-vide.eu/admin/achievement/${toDelete._id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        const res = await req.json();

        dispatch(setLoader(-1));
        
        if ([400, 401, 404].includes(req.status)) {
            setToDelete(null);
            setConfirm(false);

            setAlert([...alertMsg, {
                title: 'Une erreur s\'est produite',
                message: res.message
            }]);
            return;
        }

        if (req.status !== 200 || !res) {
            setToDelete(null);
            setConfirm(false);

            setAlert([...alertMsg, {
                title: 'Serveur indisponible',
                message: res.message
            }]);
            return;
        }

        // Mise à jour de la state 'achievments'
        const new_achievments_db = achievments_db.filter(achiev => achiev._id !== toDelete._id);
        dispatch(addAchievmentsToState(new_achievments_db));

        setAlert([...alertMsg, {
            title: 'Réalisation supprimé',
            message: `La réalisation '${toDelete.name_fr}' a bien été supprimé.`
        }])

        setToDelete(null);
        setConfirm(false);
    };


    return (
        <div className='modal modal_delete_achievments'>
            <form>
                <h1>Supprimer une réalisation</h1>

                <AchievmentSelector setToDelete={setToDelete} />
            </form>

            {toDelete && !confirm && <ConfirmDelete toDelete={toDelete} setToDelete={setToDelete} setConfirm={setConfirm} />}
            {alertMsg.length !== 0 && <AlertMessage alertMsg={alertMsg} setAlert={setAlert} />}
        </div>
    )
}

export default DeleteAchievments;